import React, { useEffect, useState } from 'react'
import StrategicImperativeTable from './StrategicImperativeTable'
import '../../style/Views.scss'
import Grid from '@mui/material/Grid'
import { ReactComponent as StrategicIcon } from '../../assets/images/Strategic_Icon.svg'
import LeftPanel from './../Support/PageLeftPanel'
import { useHistory } from 'react-router-dom'
import { isStrategySelected } from '../../utilities/helpers'
import useStrategicImperativeDisplayName from '../../shared/hooks/useDisplayNames/variants/useStrategicImperativeDisplayName'

export default function StrategicImperatives() {
    const history = useHistory()
    const [formData, setFormData] = useState({})
    const strategicImperativeDisplayName = useStrategicImperativeDisplayName()

    function createNew(incomingData) {
        setFormData(incomingData)
    }

    // if no strategy selected, navigate to strategy selection page
    useEffect(() => {
        if (!isStrategySelected()) {
            history.push('/roadmaps')
        }
    })

    return (
        <Grid container item spacing={2} direction="column" sx={{ p: 2 }}>
            <LeftPanel
                imgsrc={StrategicIcon}
                text={strategicImperativeDisplayName.plural}
                id={'strategicimperative'}
                createNew={createNew}
            />
            <StrategicImperativeTable newFormData={formData} />
        </Grid>
    )
}
